
export enum ReasonPriorityEnum {
    AVERAGE = 'AVERAGE',
    MINWAGE = 'MINWAGE',
    GUARANTEE = 'GUARANTEE',
    BASE = 'BASE'
}
